/**
 *  Created by long.wang on 2019/4/11
 */
import sensors from 'sa-sdk-javascript'
import config from '@/config'

sensors.init({
  server_url: config.sensors.server_url,
  heatmap_url: '@/static/js/sensorsdata.min.js',
  is_track_single_page: true,
  heatmap: {
    clickmap: 'default',
    scroll_notice_map: 'not_collect'
  },
  show_log: config.sensors.show_log
})
sensors.registerPage({
  product: 'inv_app',
  product_h5: 'inv_h5',
  platform: 'H5',
  h5_channel: '',
  source: 'APP',
  user_agent: window.navigator.userAgent
})
sensors.quick('autoTrack')

export default sensors
